import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import '../libraries';

import Tree from '../components/tree';
import Dialog from '../dialog/dialog';
import * as styles from '../styles';
import { request } from './actions';
import { close, setErrors } from '../dialog/actions';


export default class RegistrationDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object
    }

    state = {
        gender: null,
        openGenderBox: false,
        genderError: false
    };
    renderBody() {
        return <div style={styles.registerDialog}>
            <form
                ref='form'
                style={{ marginBottom: 0 }}
                onSubmit={async event => {
                    event.preventDefault();
                    const grade = this.props.extra.getIn(['gradesTree', 'selected']).keySeq().first();

                    if (grade === undefined || grade === '' || grade === null) {
                        this.context.store.dispatch(setErrors({
                            grade: ['لطفا پایه خود را وارد کنید'],
                        }, this.props.elementId));
                        return;
                    }

                    if (!this.state.gender) {
                        return this.setState({ genderError: true })
                    }
                    else if (this.state.gender == 1 || this.state.gender == 2) {
                        this.setState({ genderError: false })
                    }
                    try {
                        await this.context.store.dispatch(request(
                            `/user/complete_registration/`,
                            {
                                method: 'PATCH',
                                body: {
                                    gender: this.state.gender,
                                    ...this.props.extra.getIn(['gradesTree', 'selected']).size
                                        ? { grade: { id: this.props.extra.getIn(['gradesTree', 'selected']).keySeq().first() } }
                                        : {},
                                },
                            },
                        ));
                        this.context.store.dispatch(setErrors({}, this.props.elementId));
                        this.refs.form.reset();
                        this.context.store.dispatch(close(this.props.elementId));
                    }
                    catch (error) {
                        this.context.store.dispatch(setErrors(error, this.props.elementId));
                    }
                }}>
                {/* gender */}
                <div style={styles.registerRightDialogField}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        boxShadow: " rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
                        fontSize: "0.95em",
                        backgroundColor: "#fff",
                        color: "black",
                        padding: "12px",
                        color: "rgba(0, 0, 0, 0.6)",
                        height: "unset",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: "3px"
                    }}
                    >
                        <span style={{ width: "100%", height: "100%", display: "block",cursor:"pointer" ,color: `${(this.state.gender == 2 || this.state.gender == 1) ? "#000" : "rgba(0,0,0,0.6"}` }} onClick={() => {
                            this.setState({ openGenderBox: !this.state.openGenderBox });
                        }}>
                            {this.state.gender == 1 ? "مرد" : this.state.gender == 2 ? "زن" : "جنسیت"}
                        </span>
                        <span
                            style={{ cursor: "pointer", color: "rgba(100,100,100,0.7)", fontSize: "1.2em" }}
                            onClick={() => {
                                this.setState({ openGenderBox: !this.state.openGenderBox });
                            }}
                        >
                            <i className="fa-chevron-down"></i>
                        </span>

                    </div>
                    <div style={{ position: "relative",boxShadow: " rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px", zIndex: "100000", height: "76px", display: `${this.state.openGenderBox ? "block" : "none"}`, backgroundColor: "#fff", border: "1px solid  rgba(0, 0, 0, 0.12)", borderTop: "none", borderRadius: "3px" }}>
                        <div style={{ display: "flex", position: "absolute", top: "-3px", left: "0", width: "100%", flexDirection: "column", }}>
                            <div onClick={(e) => { this.setState({ gender: e.target.attributes["value"].value, openGenderBox: false, genderError: false }) }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em",cursor:"pointer" , boxSizing: "border-box", minHeight: "2.5em" }} value="1">
                                مرد
                            </div>
                            <div onClick={(e) => { this.setState({ gender: e.target.attributes["value"].value, openGenderBox: false, genderError: false }) }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em",cursor:"pointer", boxSizing: "border-box", minHeight: "2.5em" }} value="2">
                                زن
                            </div>
                        </div>
                    </div>
                    {this.state.genderError ? <span style={{ color: "RGB(255,64,129)", fontSize: "0.8em" }}
                    >
                    *
                    {" "}
                    لطفا جنسیت را انتخاب نمایید  
                    </span> : null}
                </div>

                <div style={{ ...styles.registerRightDialogField, marginTop: '1em', marginBottom: '.5em' }}>
                    <Tree
                        store={this.props.extra.get('levelsTree')}
                        readonly
                        resource='level'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Level')}
                    />
                </div>
                <div style={{ ...styles.registerLeftDialogField, marginTop: '1em', marginBottom: '.5em' }}>
                    <Tree
                        store={this.props.extra.get('gradesTree')}
                        readonly
                        required
                        resource='grade'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Grade')}
                        filter={{ level: this.props.extra.getIn(['levelsTree', 'selected']).keySeq().first() }}
                    />
                    <br />
                    <div style={styles.error}>
                        {this.props.errors.grade
                            ? _.map(
                                this.props.errors.grade,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                <div style={styles.dialogButtonContainer}>
                    {this.props.pending > 0
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : <input
                            key='submit'
                            type='submit'
                            style={styles.defaultDialogButton}
                            value={window.gettext('complete registration')}
                        />
                    }
                </div>
            </form>
        </div>;
    }


    render() {
        return <Dialog {...this.props}>
            {this.renderBody.bind(this)()}
            <span>
                <i className='fa-user-plus fa-3x'></i>
                <br />
                {window.gettext('complete registration')}
            </span>
        </Dialog>;
    }
};